import { caseFilterhash } from '@debbie/common/dist/insights/index.js';
import { h } from '../index.js';
import { setFetchStartState } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const homeReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_HOME_START:
            return {
                ...state,
                [caseFilterhash(payload.caseFilter)]: {
                    ...setFetchStartState(state[caseFilterhash(payload.caseFilter)], payload.res),
                },
            };
        case actionTypes.FETCH_HOME_SUCCESS:
        case actionTypes.FETCH_HOME_ERROR:
            return {
                ...state,
                [caseFilterhash(payload.caseFilter)]: { ...payload.res },
            };
        default:
            return state;
    }
};
export const pausedCasesReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        case actionTypes.FETCH_PAUSED_CASES_START:
            return {
                ...state,
                [caseFilterhash(payload.caseFilter)]: {
                    ...setFetchStartState(state[caseFilterhash(payload.caseFilter)], payload.res),
                },
            };
        case actionTypes.FETCH_PAUSED_CASES_SUCCESS:
        case actionTypes.FETCH_PAUSED_CASES_ERROR:
            return {
                ...state,
                [caseFilterhash(payload.caseFilter)]: { ...payload.res },
            };
        case actionTypes.UPDATE_TYPE_CONTINUED_EVENT: {
            if (state[caseFilterhash(payload.caseFilter)] &&
                h.isLoaded(state[caseFilterhash(payload.caseFilter)]) &&
                // @ts-ignore
                state[caseFilterhash(payload.caseFilter)].data) {
                return {
                    ...state,
                    [caseFilterhash(payload.caseFilter)]: {
                        ...state[caseFilterhash(payload.caseFilter)],
                        // @ts-ignore
                        data: state[caseFilterhash(payload.caseFilter)].data.map((u) => {
                            if (payload.updateTypeId === u.updateTypeId) {
                                return {
                                    ...u,
                                    count: u.count - 1,
                                };
                            }
                            return u;
                        }),
                    },
                };
            }
            return state;
        }
        case actionTypes.UPDATE_TYPE_ADDED_EVENT: {
            if (state[caseFilterhash(payload.caseFilter)] &&
                h.isLoaded(state[caseFilterhash(payload.caseFilter)]) &&
                // @ts-ignore
                state[caseFilterhash(payload.caseFilter)].data) {
                return {
                    ...state,
                    [caseFilterhash(payload.caseFilter)]: {
                        ...state[caseFilterhash(payload.caseFilter)],
                        // @ts-ignore
                        data: state[caseFilterhash(payload.caseFilter)].data.map((u) => {
                            if (payload.updateTypeId === u.updateTypeId &&
                                (!payload.update ||
                                    payload.update.responsibleReferenceId ==
                                        u.responsibleReferenceId)) {
                                return {
                                    ...u,
                                    count: u.count + 1,
                                };
                            }
                            return u;
                        }),
                    },
                };
            }
            return state;
        }
        default:
            return state;
    }
};
export const pendingCasesReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map